import React from 'react'

function Arrow({color = '#E3E3E3'}) {
    return (
        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 2.59794L1.4 6.86598L0 5.56701L6 0L12 5.56701L10.6 6.86598L6 2.59794Z" fill={color} />
        </svg>

    )
}

export default Arrow